import React from 'react'
import {
  TitleSecondary,
  ParagraphSecondary,
  SpacerVertical,
  ButtonPrimary
} from 'mage-deps/@klarna/bubble-ui'
import { Message, translator } from 'mage-i18n'
import PropTypes from 'prop-types'
import { EducationAnalytics } from 'education-tools'
import { connect } from 'react-redux'

function handleOpenChat(track) {
  track()
  if (window.fcWidget) {
    window.fcWidget.open()
    window.fcWidget.show()
  }
}

ChatContact.propTypes = {
  articleId: PropTypes.string,
  t: PropTypes.func.isRequired
}

function ChatContact({ articleId, t }) {
  return (
    <>
      <EducationAnalytics
        category="uhqm/contact"
        action="print"
        referenceType={articleId ? 'article' : undefined}
        referenceId={articleId}
        label="chat"
        googleAnalytics={false}
      />
      <EducationAnalytics
        category="uhqm/contact"
        action="click"
        referenceType={articleId ? 'article' : undefined}
        referenceId={articleId}
        label="chat"
      >
        {track => (
          <>
            <TitleSecondary>
              <Message path="hqm.contact.chat.title" fallback="Chat with us" />
            </TitleSecondary>
            <ParagraphSecondary>
              <Message
                path="hqm.contact.chat.paragraph"
                fallback="The quickest and easiest way to reach Support. Our chat is currently open. "
              />
            </ParagraphSecondary>
            <SpacerVertical extraSmall />
            <ButtonPrimary onClick={() => handleOpenChat(track)} size="medium">
              {t('hqm.contact.chat.button', {}, 'Open Chat')}
            </ButtonPrimary>
            <SpacerVertical large />
          </>
        )}
      </EducationAnalytics>
    </>
  )
}

const mapStateToProps = state => ({
  t: translator(state)
})

export default connect(mapStateToProps)(ChatContact)
